import {
  Divider,
  Grid2,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";

const Section1 = () => {
  return (
    <>
      <Typography variant="h4" gutterBottom>
        About the Application
      </Typography>
      <Typography sx={{ fontSize: "1.1rem" }} variant="body1" mb={2}>
        Soucient HRMS is an internal Human Resource Management System developed
        exclusively for use by employees of Keel Info Solution. The Application
        is available on Android, iOS and desktop platforms and is intended
        solely for managing workforce-related operations such as attendance,
        leave management, payroll access, permissions, regularization and
        performance evaluation.
      </Typography>

      <Typography  sx={{ fontSize: "1.1rem" }} >
        The Application is not offered to external organizations, is not sold
        commercially and is not available for public use. Access is strictly
        restricted to authorized employees using official login credentials
        issued by the Company.
      </Typography>
      <Divider sx={{ my: 2 }} />
    </>
  );
};

export default Section1;
